<template>
  <div class="container page">
    <van-nav-bar title="" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#333" @click="back()"/>
      </template>
      <template #right>
       <span class="nav-right" @click="$router.push({path:'/WithdrawRecord'})">Withdrawal records</span>
      </template>
    </van-nav-bar>
    <div class="main">
      <div class="form-section">
        <div class="form-item">
          <label>Select Withdrawal Channel</label>
          <div class="channel-list">
            <div 
              v-if="channelData.erc20 && channelData.erc20 !== ''"
              class="channel-card"
              :class="{ active: selectedChannel === 'erc20' }"
              @click="selectChannel('erc20')"
            >
              <div class="channel-header">
                <span class="channel-name">ERC20</span>
                <van-icon v-if="selectedChannel === 'erc20'" name="success" color="#667eea" />
              </div>
              <div class="channel-info">{{channelData.erc20.wallet_address}}</div>
              <div class="channel-detail" v-if="channelData.erc20.holder_name">{{channelData.erc20.holder_name}}</div>
            </div>
            
            <div 
              v-if="channelData.cashapp && channelData.cashapp !== ''"
              class="channel-card"
              :class="{ active: selectedChannel === 'cashapp' }"
              @click="selectChannel('cashapp')"
            >
              <div class="channel-header">
                <span class="channel-name">Cash App</span>
                <van-icon v-if="selectedChannel === 'cashapp'" name="success" color="#667eea" />
              </div>
              <div class="channel-info">{{channelData.cashapp.cashtag}}</div>
              <div class="channel-detail" v-if="channelData.cashapp.holder_name">{{channelData.cashapp.holder_name}}</div>
            </div>
            
            <div 
              v-if="channelData.paypal && channelData.paypal !== ''"
              class="channel-card"
              :class="{ active: selectedChannel === 'paypal' }"
              @click="selectChannel('paypal')"
            >
              <div class="channel-header">
                <span class="channel-name">PayPal</span>
                <van-icon v-if="selectedChannel === 'paypal'" name="success" color="#667eea" />
              </div>
              <div class="channel-info">{{channelData.paypal.paypal_email}}</div>
              <div class="channel-detail" v-if="channelData.paypal.holder_name">{{channelData.paypal.holder_name}}</div>
            </div>
          </div>
        </div>

        <div class="form-item">
          <label>Withdrawal amount</label>
          <div class="input-wrapper">
            <input v-model="withdraw_money" type="number" placeholder="Please enter the amount" />
            <span class="all-btn" @click="allMoeny()">All</span>
          </div>
        </div>

        <div class="form-item">
          <input v-model="paypassword" type="password" placeholder="Please re-enter the new withdrawal password" class="password-input" />
        </div>

        <div class="quota-info">
          <van-icon name="info-o" />
          <span @click="withdrawInfo()">Quota description</span>
        </div>

        <div class="balance-info">
          <span class="label">Balance:</span>
          <span class="amount">{{ this.userInfo.money || '0.00' }}</span>
        </div>
      </div>

      <van-button class="withdraw-btn" type="primary" @click="doWithdraw()">Instant withdrawal</van-button>

      <van-popup v-model="showPopover" position="bottom" :style="{ padding: '20px' }">
        <div class="popover-body">
          <p>1.{{$t("withdraw.single_limit")}}{{$t("withdraw.low")}}{{this.withdrawRole.min}}{{$t("withdraw.heigh")}}{{this.withdrawRole.max}}{{$t("reservation.unit")}}</p>
          <p>2.{{$t("withdraw.with_num")}}{{this.withdrawRole.num}}{{$t("withdraw.number")}}</p>
          <p>3.{{$t("withdraw.with_tip")}}</p>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showPopover: false,
      withdraw_money:"",
      paypassword:"",
      userInfo:{},
      withdrawRole:{},
      channelData: {
        erc20: '',
        cashapp: '',
        paypal: ''
      },
      selectedChannel: ''
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    getWithdrawalChannels(){
      this.$http({
        method: 'get',
        url: 'getWithdrawalChannels'
      }).then(res=>{
        if(res.code === 200){
          this.channelData = {
            erc20: res.data.erc20 || '',
            cashapp: res.data.cashapp || '',
            paypal: res.data.paypal || ''
          };
          
          // 自动选择第一个已绑定的渠道
          if(this.channelData.erc20 && this.channelData.erc20 !== ''){
            this.selectedChannel = 'erc20';
          } else if(this.channelData.cashapp && this.channelData.cashapp !== ''){
            this.selectedChannel = 'cashapp';
          } else if(this.channelData.paypal && this.channelData.paypal !== ''){
            this.selectedChannel = 'paypal';
          }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    selectChannel(channel) {
      this.selectedChannel = channel;
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.name = res.data.name;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserWithdrawRole(){
      this.$http({
        method: 'get',
        url: 'user_get_withdraw_role'
      }).then(res=>{
        if(res.code === 200){
          this.withdrawRole = res.data;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    allMoeny(){
      this.withdraw_money = this.userInfo.money;
    },
    doWithdraw(){
      // 检查是否选择渠道
      if (!this.selectedChannel) {
        this.$toast.fail('Please select withdrawal channel');
        return;
      }
      // 检查是否设置资金密码
      if (!this.userInfo.paypassword) {
        this.$router.push("SetPayPassword?from=withdraw");
        return;
      }
      if(this.withdraw_money <= 0){
        this.$toast.fail('Please enter correct amount');
        return false;
      }else {
        this.$http({
          method: 'post',
          data:{
            money: this.withdraw_money, 
            paypassword: this.paypassword,
            channel_type: this.selectedChannel
          },
          url: 'user_set_withdraw'
        }).then(res=>{
          if(res.code === 200){
            location.reload()
            this.$toast.success(res.msg);
            this.getUserInfo();
            this.getUserWithdrawRole();
          }else if(res.code ===401){
            this.$toast.fail(res.msg);
          }
        })
      }
    },
    withdrawInfo(){
      this.showPopover = true;
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
      this.getUserWithdrawRole();
      this.getWithdrawalChannels();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.page {
  background-color: #f5f5f5;
}

.nav-bar {
  background-color: #fff;
}

::v-deep .van-nav-bar__title {
  color: #333;
}

.nav-right {
  color: #5b68df;
  font-size: 0.37333rem;
}

.main {
  padding: 0.4rem;
  min-height: calc(100vh - 1.22667rem);
}

.form-section {
  background: #fff;
  border-radius: 0.2rem;
  padding: 0.4rem;
  margin-bottom: 0.4rem;
}

.form-item {
  margin-bottom: 0.4rem;
}

.form-item label {
  display: block;
  font-size: 0.47333rem;
  color: #333;
  margin-bottom: 0.2rem;
  font-weight: 700;
}

.channel-list {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.channel-card {
  background: #f5f5f5;
  border-radius: 0.2rem;
  padding: 0.3rem;
  cursor: pointer;
  border: 0.02667rem solid transparent;
  transition: all 0.3s;
}

.channel-card.active {
  background: #f0f2ff;
  border-color: #667eea;
}

.channel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.15rem;
}

.channel-name {
  font-size: 0.4rem;
  color: #333;
  font-weight: 600;
}

.channel-info {
  font-size: 0.32rem;
  color: #666;
  word-break: break-all;
  margin-bottom: 0.1rem;
}

.channel-detail {
  font-size: 0.28rem;
  color: #999;
}

.network-select {
  display: none;
}

.address-text {
  display: none;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  border-bottom: 0.02667rem solid #e5e5e5;
  padding-bottom: 0.2rem;
}

.input-wrapper input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 0.42667rem;
  color: #333;
}

.input-wrapper input::placeholder {
  color: #ccc;
  font-size: 0.37333rem;
}

.all-btn {
  color: #e74c3c;
  font-size: 0.37333rem;
  font-weight: 500;
  cursor: pointer;
}

.password-input {
  width: 100%;
  border: none;
  border-bottom: 0.02667rem solid #e5e5e5;
  outline: none;
  font-size: 0.37333rem;
}

.password-input::placeholder {
  color: #ccc;
}

.quota-info {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 0.3rem 0;
  color: #666;
  font-size: 0.42rem;
}

.quota-info .van-icon {
  margin-right: 0.1rem;
  font-size: 0.42rem;
}

.balance-info {
  justify-content: space-between;
  align-items: center;
  padding-top: 0.3rem;
}

.balance-info .label {
  font-size: 0.32rem;
  color: #666;
}

.balance-info .amount {
  font-size: 0.42667rem;
  color: #e74c3c;
  font-weight: bold;
}

.withdraw-btn {
  width: 100%;
  height: 1.2rem;
  line-height: 1.2rem;
  border-radius: 0.6rem;
  font-size: 0.42667rem;
  font-weight: bold;
  border: none;
  background: linear-gradient(90deg, #667eea 0%, #667eea 100%);
  color: #fff;
}

.popover-body {
  padding: 0.4rem;
}

.popover-body p {
  font-size: 0.32rem;
  color: #666;
  line-height: 1.6;
  margin-bottom: 0.2rem;
}

::v-deep .van-popup {
  border-radius: 0.2rem 0.2rem 0 0;
}
</style>
